// extracted by mini-css-extract-plugin
export default {"wrapper":"G4fd586"};